import type { Theme } from '@mui/material';

export const styles = {
  modalRoot: {
    '& [role=dialog]': {
      padding: 0,
      margin: 0,
      overflow: 'hidden',
      height: 'calc(100vh - 44px)',
      maxWidth: '1440px',
    },
  },

  dialogTitle: (theme: Theme) => ({
    border: `1px solid ${theme.colors.neutral[100]}`,
    borderTopRightRadius: '0.5rem',
    borderTopLeftRadius: '0.5rem',
    px: 4,
    pt: 2.75,
    pb: 2,
  }),

  button: {
    px: 0,

    '&:hover': {
      backgroundColor: 'unset',
    },
  },

  expand: (showPath: boolean) => ({
    transform: showPath ? 'rotate(180deg)' : null,
  }),

  pill: (theme: Theme) => ({
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    borderRadius: '40px',
    px: 1,
    py: 0.25,
    my: 0.5,
    backgroundColor: theme.colors.neutral[200],
    color: theme.colors.neutral[600],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  }),
  priorityPill: (theme: Theme) => ({
    backgroundColor: theme.colors.secondary[50],
    color: theme.colors.secondary[800],
  }),
};
